import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Colors } from '../utils/Colors';
import { LinkButton } from './LinkButton';

const titleStyle = {
  fontSize: '36px',
  color: Colors.richBlack,
  marginBottom: '30px'
};

export function QuickLinks() {
  const navigate = useNavigate();
  function NavigateToReports() {
    navigate('/reports');
  }
  function NavigateToBanBook() {
    navigate('/ban-book');
  }
  function NavigateToAnxietySurvey() {
    navigate('/anxiety-survey');
  }
  // function NavigateToAccommodationTracker() {
  //   navigate('/accommodation-tracker');
  // }
  return (
    <Grid
      container
      direction="row"
      spacing={1}
      marginBottom="30px"
      marginTop="30px"
    >
      <Grid item xs={12}>
        <Typography variant="h3" style={titleStyle}>
          Quick Links
        </Typography>
      </Grid>
      <Grid item xs={12} lg={3}>
        {/* Need to change hows this functions. not sure i like functions for each link */}
        <LinkButton
          buttonText="REPORTS"
          handleClick={NavigateToReports}
          overrideStyles={{ width: '90%' }}
        />
      </Grid>
      <Grid item xs={12} lg={3}>
        {/* Need to change hows this functions */}
        <LinkButton
          buttonText="COMPULSION TRACKER"
          handleClick={NavigateToBanBook}
          overrideStyles={{ width: '90%' }}
        />
      </Grid>
      <Grid item xs={12} lg={3}>
        {/* Need to change hows this functions */}
        <LinkButton
          buttonText="ANXIETY SURVEY"
          handleClick={NavigateToAnxietySurvey}
          overrideStyles={{ width: '90%' }}
        />
      </Grid>
      {/* <Grid item xs={12} lg={3}>
        <LinkButton
          buttonText="ACCOMMODATION TRACKER"
          handleClick={NavigateToAccommodationTracker}
          overrideStyles={{ width: '90%' }}
        />
      </Grid> */}
    </Grid>
  );
}
